import { lockScreenScroll } from '../utils/treatment';
import { showPartialsFixed } from './partialsFixed';

const btnCallForm = document.querySelectorAll('.button-call-form');
const closeFormMobile = document.querySelectorAll('.btn-close-form');
const formMain = document.querySelector('.form-main');

const formMainMobile = document.querySelector('.form-main-mobile');
const selectModelsWrapper = document.querySelectorAll("select[name=produto]");
const headerScrolled = document.querySelector('.header-fixed');


// FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
export function buttonCotationBehavior(button) {
  let buttonSelected = document.querySelectorAll(button);

  buttonSelected.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('button-product-cotation')) {
        const dataModel = btn.getAttribute("data-model");

        selectModelsWrapper.forEach((select) => {
          select.value = dataModel;
        });

        if (window.innerWidth >= 992) {
          if (!headerScrolled.classList.contains('show-header-scrolled')) {
            setTimeout(() => {window.scrollTo(0, 710)}, 50);
            showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
          }
        }

        showFixedForm();
        lockScreenScroll();

      } else {
        showFixedForm();
        lockScreenScroll();
      }
    });
  });
}

// FUNCTION TO SHOW FIXED FORM
function showFixedForm() {
  if (window.innerWidth >= 992) {
    btnCallForm.forEach((btn) => {
      btn.innerHTML === "Minimizar"
      ? btn.innerHTML = "Solicitar cotação"
      : btn.innerHTML = "Minimizar";

      btn.classList.toggle('btn-ternary');
    });

    formMain.classList.toggle('form-content-fixed');
  } else {
    formMainMobile.classList.add('d-flex');
  }
}

// BUTTON TO CLOSE FORM IN MOBILE
closeFormMobile.forEach((btnClose) => {
  btnClose.addEventListener('click', () => {
    formMainMobile.classList.remove('d-flex');
    lockScreenScroll();
  });
});
